import { call, put, takeLatest } from 'redux-saga/effects'
import { PayloadAction } from '@reduxjs/toolkit'

import chatroomModel, { ChatRoom } from '@/core/models/chat-room.model'

import {
  getChatRoom as getChatRoomAction,
  getChatRoomSuccess as getChatRoomSuccessAction,
  getChatRoomFailure as getChatRoomFailureAction,
  confirmReadingMessages as confirmReadingMessagesAction,
  sendChatMessage as sendChatMessageAction,
  sendChatMessageSuccess as sendChatMessageSuccessAction,
  sendChatMessageFailure as sendChatMessageFailureAction,
} from '@/redux/reducers/chat-room.reducer'

import { handleError } from '@/utils/errors'

function* getChatRoom(action: PayloadAction<ReturnType<typeof getChatRoomAction>['payload']>) {
  try {
    const chatRoomId = action.payload
    const consultation: ChatRoom = yield call(chatroomModel.getChatRoom, chatRoomId)
    yield put(getChatRoomSuccessAction(consultation))
  } catch (exception) {
    yield put(getChatRoomFailureAction(handleError(exception)))
  }
}

function* sendChatMessage(action: PayloadAction<ReturnType<typeof sendChatMessageAction>['payload']>) {
  try {
    const { chatRoomId, message } = action.payload
    yield call(chatroomModel.sendChatMessage, chatRoomId, message)
    yield put(sendChatMessageSuccessAction())
  } catch (exception) {
    yield put(sendChatMessageFailureAction(handleError(exception)))
  }
}

function* confirmReadingMessages(action: PayloadAction<ReturnType<typeof confirmReadingMessagesAction>['payload']>) {
  try {
    const chatRoomId = action.payload
    yield call(chatroomModel.confirmReadingMessages, chatRoomId)
  } catch (exception) {
    yield put(sendChatMessageFailureAction(handleError(exception)))
  }
}

const sagas = [
  takeLatest(getChatRoomAction.type, getChatRoom),
  takeLatest(sendChatMessageAction.type, sendChatMessage),
  takeLatest(confirmReadingMessagesAction.type, confirmReadingMessages),
]

export default sagas
